import "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

document.addEventListener("DOMContentLoaded", () => {
	const cc = initCookieConsent();

	cc.run({
		current_lang: 'cs',
		autoclear_cookies: true,
		page_scripts: true,
		remove_cookie_tables: true,
		revision: 0,
		gui_options: {
			consent_modal: {
				layout: 'cloud',
				position: 'bottom center',
			}
		},
		languages: {
			'cs': {
				consent_modal: {
					title: 'Na vašem soukromí nám záleží',
					description: 'Vzhledem k nové legislativě platné od 1. 1. 2022 od vás potřebujeme souhlas s používáním souborů cookies.',
					primary_btn: {
						text: 'Povolit vše',
						role: 'accept_all'
					},
					secondary_btn: {
						text: 'Nastavení',
						role: 'settings'
					}
				},
				settings_modal: {
					title: 'Nastavení cookies',
					save_settings_btn: 'Uložit nastavení',
					accept_all_btn: 'Povolit vše',
					reject_all_btn: 'Zakázat vše',
					close_btn_label: 'Zavřít',
					blocks: [
						{
							title: 'Co jsou cookies?',
							description: 'Cookies jsou malé textové soubory, které mohou být používány webovými stránkami, aby zefektivnily uživatelský zážitek a zlepšili například vaší orientaci na webu.<br /><br />Zákon uvádí, že můžeme ukládat cookies na vašem zařízení, pokud jsou nezbytně nutné pro provoz této stránky. Pro všechny ostatní typy cookies potřebujeme vaše povolení.'
						}, {
							title: 'Technické cookies (nezbytné)',
							toggle: {
								value: 'necessary',
								enabled: true,
								readonly: true
							}
						}, {
							title: 'Analytické cookies',
							toggle: {
								value: 'analytics',
								enabled: false,
								readonly: false
							},
						}, {
							title: 'Marketingové cookies',
							toggle: {
								value: 'targeting',
								enabled: false,
								readonly: false
							}
						}, {
							title: 'Kontakt',
							description: 'Pro více informací nás kontaktujte na <a class="cc-link" href="mailto:info@andys.cz">info@andys.cz</a>.',
						}
					]
				}
			}
		}
	});
});
